import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

const KreistagwahlPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Kreistagswahl 2026 - AfD Kandidaten für den Kreistag',
    description: 'Unsere 20 Kreistagskandidaten für die Kommunalwahl 2026. Informationen zur Kreistagswahl und wie Sie die AfD-Liste 3 mit 60 Stimmen unterstützen können.',
    keywords: 'Kreistagswahl 2026, AfD Kreistag, Kommunalwahl Landkreis, Liste 3 AfD, Kreistagskandidaten',
    canonical: `${siteUrl}/kreistagswahl`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: 'Kreistagswahl 2026',
      description: 'Kommunalwahl für den Kreistag',
      startDate: '2026-03-15',
      location: {
        '@type': 'Place',
        name: 'Landkreis Neustadt an der Aisch-Bad Windsheim',
        address: {
          '@type': 'PostalAddress',
          addressRegion: 'Bayern',
          addressCountry: 'DE'
        }
      }
    }
  });

  const kreistagCandidates = [
    { id: 1, name: "Armin Heinlein", age: 41, location: "Obernzenn", profession: "Technischer Betriebswirt" },
    { id: 2, name: "Dennis Neumeister", age: 26, location: "Bad Windsheim", profession: "Bauzeichner, Student Bauingenieurwesen" },
    { id: 3, name: "Anni Benedikt", age: 76, location: "Münchsteinach", profession: "Rentnerin, Kreisrätin" },
    { id: 4, name: "Dr. Benno Bulitta", age: 75, location: "Bad Windsheim", profession: "Dipl.-Volkswirt" },
    { id: 5, name: "Monika Hartmann", age: 39, location: "Bad Windsheim", profession: "Verkäuferin" },
    { id: 6, name: "Friedrich Summ", age: 72, location: "Ipsheim", profession: "Techniker für Landbau" },
    { id: 7, name: "Manuel Edenharter", age: 35, location: "Emskirchen", profession: "Koch" },
    { id: 8, name: "Ralph Mebus", age: 29, location: "Obernzenn", profession: "Polier" },
    { id: 9, name: "Ute Heinlein", age: 65, location: "Obernzenn", profession: "Gerontopsychiatrische Fachkraft" },
    { id: 10, name: "Karen Wittich", age: 34, location: "Bad Windsheim", profession: "Sicherheitsmitarbeiterin" },
    { id: 11, name: "Ingrid Benedikt", age: 46, location: "Münchsteinach", profession: "Klassische Philologin" },
    { id: 12, name: "Silvio Grube", age: 50, location: "Bad Windsheim", profession: "Sicherheitsmitarbeiter" },
    { id: 13, name: "Daniel Fleischmann", age: 25, location: "Obernzenn", profession: "Arbeiter" },
    { id: 14, name: "Susi Kraus", age: 67, location: "Obernzenn", profession: "Busfahrerin" },
    { id: 15, name: "Thomas Nölp", age: 33, location: "Bad Windsheim", profession: "Industriemechaniker" },
    { id: 16, name: "Christian Pogge", age: 42, location: "Obernzenn", profession: "Landschaftsgärtner" },
    { id: 17, name: "Ramona Nölp", age: 43, location: "Bad Windsheim", profession: "Verkäuferin" },
    { id: 18, name: "Ronny Schmitt-Schwarz", age: 47, location: "Trautskirchen", profession: "Koch" },
    { id: 19, name: "Christina Schmitt", age: 45, location: "Trautskrichen", profession: "Hausfrau" },
    { id: 20, name: "Bennie Crawford", age: 24, location: "Bad Windsheim", profession: "Baufinanzierungsberater" }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-primary-600 to-primary-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <div className="w-2 h-2 bg-white rounded-full"></div>
            <span className="text-sm font-semibold tracking-wider uppercase">Kommunalwahl 2026</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Informationen zur Kreistagswahl
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl">
            Alles Wichtige zur Kreistagswahl und unsere Kandidaten für den Kreistag.
          </p>
        </div>
      </section>

      {/* Candidates List */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 mb-6">
              <div className="w-12 h-1 bg-secondary-600"></div>
              <span className="text-secondary-600 font-semibold uppercase tracking-wider text-sm">Unser Team</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Unsere Kreistagskandidaten
            </h2>
            <p className="text-xl text-gray-600">
              20 engagierte Kandidaten für den Kreistag
            </p>
          </div>

          <div className="bg-gradient-to-br from-primary-50 to-white rounded-2xl p-8 md:p-12 shadow-xl border-2 border-primary-200">
            <div className="grid md:grid-cols-2 gap-6">
              {kreistagCandidates.map((candidate) => (
                <div 
                  key={candidate.id}
                  className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-secondary-300"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-secondary-600 to-secondary-700 text-white rounded-lg flex items-center justify-center font-bold text-lg flex-shrink-0">
                      {candidate.id}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-1">{candidate.name}</h3>
                      <p className="text-sm text-gray-600 mb-1">
                        {candidate.age} Jahre, {candidate.location}
                      </p>
                      <p className="text-sm text-gray-700 font-medium">{candidate.profession}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Photos */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-primary-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">Unser Team im Einsatz</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="rounded-xl overflow-hidden shadow-xl border-4 border-white">
              <img 
                src="https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Kreistagsbild+AfD-1920w.jpg"
                alt="Kreistagsteam AfD"
                className="w-full h-auto"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-xl border-4 border-white">
              <img 
                src="https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Bild+AfD+Weihnachtsmarkt-1920w.jpg"
                alt="AfD am Weihnachtsmarkt"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Voting Instructions */}
      <section className="py-24 bg-gradient-to-br from-secondary-600 to-secondary-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-information-line"></i>
            <span className="text-sm font-semibold tracking-wider uppercase">So wählen Sie uns</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            So unterstützen Sie unser Team bei der Kreistagswahl
          </h2>
          <p className="text-2xl mb-8 leading-relaxed">
            Bitte kreuzen Sie einfach die <span className="font-bold underline">Liste 3 - AfD</span> oben an,
          </p>
          <p className="text-xl mb-8 text-red-100">
            dann erhält jeder Kandidat drei Stimmen und Sie haben Ihr volles Stimmen-Potenzial von <span className="font-bold text-white">60 Stimmen</span> ausgenutzt.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/stadtratswahl" 
              className="bg-white text-secondary-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Zur Stadtratswahl
            </Link>
            <Link 
              to="/" 
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Zur Startseite
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-primary-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">Kontakt</h2>
          <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-primary-200">
            <p className="text-gray-700 mb-2"><strong>Telefonnummer:</strong></p>
            <p className="text-2xl font-bold text-secondary-600 mb-6">0155 - 688 44 604</p>
            <p className="text-gray-700 mb-2"><strong>Verantwortlich für diese Website:</strong></p>
            <p className="text-lg font-semibold mb-1">Dr. Benno Bulitta</p>
            <p className="text-gray-600">Augustinumstraße 4</p>
            <p className="text-gray-600">91438 Bad Windsheim</p>
            <p className="text-gray-600 mt-4">E-Mail: benno.bulitta@web.de</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KreistagwahlPage;
